import { render, staticRenderFns } from "./RichForm.vue?vue&type=template&id=adbca1a0"
import script from "./RichForm.vue?vue&type=script&lang=js"
export * from "./RichForm.vue?vue&type=script&lang=js"
import style0 from "./RichForm.vue?vue&type=style&index=0&id=adbca1a0&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports